import { MobileOutlined, TabletOutlined, DesktopOutlined, GlobalOutlined } from "@ant-design/icons";

/**
 * A user agent, read the way a person would describe it.
 *
 * Deliberately shallow: the full string belongs in a tooltip, because this
 * column is scanned for "was this the same device" rather than parsed for a
 * version number.
 *
 * Shared by the customer's own login history and the CMS team's, which show the
 * same fact about two different sets of people.
 *
 * @returns {{icon: JSX.Element, label: string}}
 */
export const parseAgent = (ua = "") => {
  const s = String(ua);
  if (!s) return { icon: <GlobalOutlined />, label: "Unknown" };

  const mobile = /iPhone|Android.*Mobile|Windows Phone/i.test(s);
  const tablet = /iPad|Android(?!.*Mobile)|Tablet/i.test(s);

  const os = /iPhone|iPad|iPod/i.test(s) ? "iOS"
    : /Android/i.test(s) ? "Android"
      : /Windows/i.test(s) ? "Windows"
        : /Mac OS X|Macintosh/i.test(s) ? "macOS"
          : /Linux/i.test(s) ? "Linux" : "";

  /* Order matters — Edge, Opera and Chrome all claim to be Safari in their user
     agent, and Edge also claims to be Chrome. The most specific name has to be
     tested first or every browser reads as Safari. */
  const browser = /Edg\//i.test(s) ? "Edge"
    : /OPR\/|Opera/i.test(s) ? "Opera"
      : /Chrome\//i.test(s) ? "Chrome"
        : /Firefox\//i.test(s) ? "Firefox"
          : /Safari\//i.test(s) ? "Safari" : "";

  return {
    icon: mobile ? <MobileOutlined /> : tablet ? <TabletOutlined /> : <DesktopOutlined />,
    label: [browser, os].filter(Boolean).join(" · ") || "Unknown",
  };
};
